export default "__VITE_ASSET__Bbr6cnJj__"